exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_wks-ext.js
// module id = 8f79d9e57207295785ef
// module chunks = 90